import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalizationModule } from '@nimbus-library/features/localization/localization.module';
import { WrongLocationPageComponent } from './wrong-location-page.component';
import { WrongLocationPageRoutingModule } from './wrong-location-page.routing.module';

@NgModule({
  declarations: [WrongLocationPageComponent],
  imports: [CommonModule, WrongLocationPageRoutingModule, LocalizationModule],
})
export class WrongLocationPageModule {}
